/**
 * The type of a tier stream for deviation page sidebar content. Maps directly to backend values.
 */
export var TierStreamType;
(function (TierStreamType) {
    /** Only on tier deviation pages. Contains the tier that we're viewing. */
    TierStreamType["SelectedTier"] = "selectedTier";
    /** Only on tier deviation pages. More tiers from the user that owns the tier we're viewing. */
    TierStreamType["MoreTiers"] = "moreTiers";
    /** Only on non-tier deviation pages. Indicates that the deviation we're viewing is included in some of the owner's tiers */
    TierStreamType["InTiers"] = "inTiers";
})(TierStreamType || (TierStreamType = {}));
//# sourceMappingURL=types.js.map